import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, concatMap, map, of, throwError } from 'rxjs';
import { AddBillingitemsWizardDataV26Service } from 'src/app/services-v26/wizards/add-billingitems-wizard-v26.service';
import { AddServicesToContractsWizardActionsV26 } from '.';
import { State } from './state';

@Injectable()
export class AddServicesToContractsWizardEffects {
  newAddServicesToContracts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddServicesToContractsWizardActionsV26.createNewAddServicesToContracts),
      concatMap(({ request }) =>
        this.addBillingitemsWizardService.addBillingitemsToContracts(request).pipe(
          map((response) => {
            if (response) {
              return AddServicesToContractsWizardActionsV26.createNewAddServicesToContractsSuccess({
                response: response.data,
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(AddServicesToContractsWizardActionsV26.createNewAddServicesToContractsFail({ errorMessage }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private addBillingitemsWizardService: AddBillingitemsWizardDataV26Service,
  ) {}
}
